export enum ClientDocumentTypeEnum {
  DOCUMENT = 'DOCUMENT',
  DOCUMENT_BACK = 'DOCUMENT_BACK',
  CARD = 'CARD',
  RECEIPT = 'RECEIPT',
}
